(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-dark-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
    const pageTemplate = document.querySelector('#MainContent')?.dataset?.template || '';
    if (!pageTemplate.includes('product.dark')) return;

    const pad = (value) => String(value).padStart(2, '0');

    const tick = () => {
      const now = Date.now();
      document.querySelectorAll('.product-dark-countdown[data-target-epoch]').forEach((box) => {
        const targetEpoch = Number(box.dataset.targetEpoch || 0) * 1000;
        if (!targetEpoch) return;

        const diff = Math.max(targetEpoch - now, 0);
        const totalSeconds = Math.floor(diff / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const dEl = box.querySelector('[data-countdown-unit="days"]');
        const hEl = box.querySelector('[data-countdown-unit="hours"]');
        const mEl = box.querySelector('[data-countdown-unit="minutes"]');
        const sEl = box.querySelector('[data-countdown-unit="seconds"]');
        if (dEl) dEl.textContent = pad(days);
        if (hEl) hEl.textContent = pad(hours);
        if (mEl) mEl.textContent = pad(minutes);
        if (sEl) sEl.textContent = pad(seconds);
      });
    };

    tick();
    setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-dark-delivery-box"] && !Shopify.designMode) return;
  try {
    (() => {
    const pageTemplate = document.querySelector('#MainContent')?.dataset?.template || '';
    if (!pageTemplate.includes('product.dark')) return;

    const pad = (value) => String(value).padStart(2, '0');

    const nowInTimeZone = (tz) => {
      const real = new Date();
      if (!tz) return real;
      try {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: tz,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        }).formatToParts(real);
        const map = {};
        parts.forEach((part) => {
          if (part.type !== 'literal') map[part.type] = part.value;
        });
        const hour = map.hour === '24' ? 0 : Number(map.hour);
        return new Date(
          Number(map.year),
          Number(map.month) - 1,
          Number(map.day),
          hour,
          Number(map.minute),
          Number(map.second)
        );
      } catch (error) {
        return real;
      }
    };

    const storeTimeZone =
      document.querySelector('.product-dark-delivery-box')?.dataset?.timezone || 'Europe/Istanbul';

    const toDateKey = (date) => {
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      return `${year}-${month}-${day}`;
    };

    const getHolidayDates = (box) => {
      return new Set(
        (box.dataset.holidayDates || '')
          .split(',')
          .map((date) => date.trim())
          .filter(Boolean)
      );
    };

    const isTomorrowHoliday = (now, holidayDates) => {
      const tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow.getDay() === 0 || holidayDates.has(toDateKey(tomorrow));
    };

    const isBusinessDay = (date, holidayDates) => {
      const day = date.getDay();
      return day !== 0 && !holidayDates.has(toDateKey(date));
    };

    const nextBusinessDate = (date, holidayDates) => {
      const result = new Date(date);
      while (!isBusinessDay(result, holidayDates)) {
        result.setDate(result.getDate() + 1);
      }
      return result;
    };

    const addBusinessDays = (date, businessDays, holidayDates) => {
      const result = new Date(date);
      let remainingDays = Number(businessDays) || 0;

      while (remainingDays > 0) {
        result.setDate(result.getDate() + 1);
        if (isBusinessDay(result, holidayDates)) {
          remainingDays -= 1;
        }
      }

      return nextBusinessDate(result, holidayDates);
    };

    const formatDate = (date) => {
      return new Intl.DateTimeFormat('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(date);
    };

    const getDeliveryTarget = (box, now) => {
      const targetMode = box.dataset.targetMode || 'cutoff';
      const cutoffHour = Number(box.dataset.cutoffHour || 12);
      const cutoffMinute = Number(box.dataset.cutoffMinute || 0);
      const targetOffsetDays = Number(box.dataset.targetOffsetDays || 0);
      const target = new Date(now);

      if (targetMode === 'midnight') {
        target.setHours(24, 0, 0, 0);
        target.setDate(target.getDate() + targetOffsetDays - 1);
        return target;
      }

      target.setHours(cutoffHour, cutoffMinute, 0, 0);
      if (targetOffsetDays > 0) {
        target.setDate(target.getDate() + targetOffsetDays);
      }
      return target;
    };

    const updateDeliveryCountdown = (now) => {
      document.querySelectorAll('.product-dark-delivery-box').forEach((box) => {
        const showTimer = box.dataset.showTimer === 'true';
        const shipDateElement = box.querySelector('[data-delivery-date="ship"]');
        const estimateDateElement = box.querySelector('[data-delivery-date="estimate"]');
        const headlineElement = box.querySelector('[data-delivery-headline]');
        const timerElement = box.querySelector('.delivery-countdown-timer');
        const deliveryMessageElement = box.querySelector('[data-delivery-message]');
        const defaultDeliveryMessage = (box.dataset.todayMessage || 'Bugün kargoda').toLowerCase();
        const afterCutoffMessage = (box.dataset.afterCutoffMessage || 'Yarın kargoda').toLowerCase();
        const holidayDates = getHolidayDates(box);

        let baseShipDate = nextBusinessDate(new Date(now), holidayDates);
        if (showTimer) {
          const target = getDeliveryTarget(box, now);
          const cutoffTarget = new Date(now);
          cutoffTarget.setHours(Number(box.dataset.cutoffHour || 12), Number(box.dataset.cutoffMinute || 0), 0, 0);
          const isPastCutoff = (box.dataset.targetMode || 'cutoff') === 'cutoff' && now.getTime() >= cutoffTarget.getTime();
          const effectiveTarget = isPastCutoff ? new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1) : target;
          const diff = Math.max(effectiveTarget.getTime() - now.getTime(), 0);
          const totalSeconds = Math.floor(diff / 1000);
          const hours = Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;
          if (timerElement) {
            timerElement.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
          }

          const shouldFallbackToFastShipping = isPastCutoff && afterCutoffMessage === 'yarın kargoda' && isTomorrowHoliday(now, holidayDates);
          if (shouldFallbackToFastShipping && headlineElement) {
            headlineElement.textContent = 'Hızlı Kargo';
          } else if (deliveryMessageElement) {
            deliveryMessageElement.textContent = isPastCutoff ? afterCutoffMessage : defaultDeliveryMessage;
          }

          if ((box.dataset.targetMode || 'cutoff') === 'midnight' || isPastCutoff) {
            baseShipDate = new Date(now);
            baseShipDate.setDate(baseShipDate.getDate() + 1);
            baseShipDate = nextBusinessDate(baseShipDate, holidayDates);
          }
        } else {
          const leadDaysMatch = (shipDateElement?.textContent || '').match(/(\d+)/);
          const leadDays = leadDaysMatch ? Number(leadDaysMatch[1]) : 0;
          baseShipDate = nextBusinessDate(new Date(now), holidayDates);
          if (leadDays > 0) {
            baseShipDate = addBusinessDays(baseShipDate, leadDays, holidayDates);
            if (shipDateElement) {
              shipDateElement.textContent = `${leadDays} gün içinde`;
            }
          }
        }

        if (showTimer && shipDateElement) {
          shipDateElement.textContent = formatDate(baseShipDate);
        }

        if (estimateDateElement) {
          const minBusinessDays = Number(estimateDateElement.dataset.minBusinessDays || 1);
          const maxBusinessDays = Number(estimateDateElement.dataset.maxBusinessDays || minBusinessDays);
          const minDate = addBusinessDays(baseShipDate, minBusinessDays, holidayDates);
          const maxDate = addBusinessDays(baseShipDate, maxBusinessDays, holidayDates);
          estimateDateElement.textContent = `${formatDate(minDate)} - ${formatDate(maxDate)}`;
        }
      });
    };

    const tick = () => updateDeliveryCountdown(nowInTimeZone(storeTimeZone));
    tick();
    setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
